<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh-break" id="char"> </p>
<p class="fmh"><span class="epub-b">Major Characters</span></p>
<p class="lh-nosp"><span class="epub-b">United States</span></p>
<p class="ul"><span class="epub-i">Josh MacArthur, scientist</span></p>
<p class="ul"><span class="epub-i">Mara Duncan, CIA officer</span></p>
<p class="ul"><span class="epub-i">Peter Lucas, CIA chief of station, Bangkok/Southeast Asia</span></p>
<p class="ul"><span class="epub-i">Major Zeus Murphy, former SF captain, adviser to Vietnam People’s Army</span></p>
<p class="ul"><span class="epub-i">Lieutenant Ric Kerfer, SEAL Team platoon commander</span></p>
<p class="ul"><span class="epub-i">President George Chester Greene</span></p>
<p class="ul"><span class="epub-i">CIA Director Peter Frost</span></p>
<p class="ul"><span class="epub-i">National Security Adviser Walter Jackson</span></p>
<p class="lh"><span class="epub-b">China</span></p>
<p class="ul"><span class="epub-i">Lieutenant Jing Yo, commander, First Commando Detachment</span></p>
<p class="ul"><span class="epub-i">Colonel Li Sun, Commando Regiment commander, executive officer Task Force #1</span></p>
<p class="ul"><span class="epub-i">Premier Cho Lai</span></p>
<p class="lh"><span class="epub-b">Vietnam</span></p>
<p class="ul"><span class="epub-i">Premier Lein Thap</span></p>
<p class="ul"><span class="epub-i">General Minh Trung, head of the Vietnam People’s Army</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// characters.vue?ae027796